/** @format */

import React, { useState, useEffect } from 'react'
import { _$, Button, Icon, Dialog, Message, Switch } from '@king-design/react'
import styled from 'styled-components'
import { MonitorSearch, TablePage, Divider } from 'src/components'
import API from 'src/api/ApiContacts'
import { TableItemProps } from 'src/containers/MonitorContacts/constants'
import useFormTable from 'src/hooks/useFormTable'
import ContactsDrawer from 'src/containers/MonitorContacts/ContactsDrawer'
import { request } from 'src/utils'

const Contacts: React.FC<{ className?: string }> = ({ className }) => {
  const [query, setQuery] = useState<string>('')
  const [tableData, setTableData] = useState<any[]>([])
  const [drawerVisible, setDrawerVisible] = useState<boolean>(false)
  const [curUser, setCurUser] = useState<TableItemProps>({})
  const [tableGroup, setTableGroup] = useState<{ status: number }>({ status: 0 })

  // useFormTable
  const { run, total, pageState, loading } = useFormTable(
    API.getAlertUser,
    {
      params: {
        Query: query,
        Cap: 1,
        Enabled: tableGroup.status || ''
      },
      manual: true
    },
    data => {
      setTableData(data?.userlist || [])
      return {
        tableData: data?.userlist,
        totalCount: data?.totalcount
      }
    }
  )

  // 删除联系人
  const deleteUser = async userIds => {
    if (userIds?.length) {
      const result = await request(API.delAlertUse, {
        method: 'POST',
        data: {
          UserIdList: userIds
        }
      })
      if (result.code === 'Success') {
        run({
          Query: query,
          Enabled: tableGroup.status || ''
        })
        Message.success(_$('删除成功'))
      }
    }
  }

  // 修改联系人状态
  const updateUserStatus = async (userId, status) => {
    if (userId?.length && status) {
      const result = await request(API.updateAlertUseStatus, {
        method: 'PUT',
        data: {
          userId,
          status
        }
      })
      if (result.code === 'Success') {
        run({
          Query: query
        })
        Message.success(_$('操作成功'))
      }
    }
  }

  // table scheme
  const tableScheme = {
    name: {
      title: _$('姓名'),
      minWidth: 100,
      template({ name }) {
        return <p className="text-overflow">{name}</p>
      }
    },
    status: {
      title: _$('状态'),
      minwidth: 80,
      group: [
        { label: _$('全部'), value: 0 },
        { label: _$('启用'), value: 1 },
        { label: _$('禁用'), value: 2 }
      ],
      template({ status, name, userid }) {
        return (
          <Switch
            size="small"
            value={status === 1 ? true : false}
            beforeChange={async from => {
              if (from) {
                const result = await Dialog.confirm({
                  title: name,
                  content: _$('确认停用所选联系人'),
                  okText: _$('确认')
                }).then(
                  res => {
                    return true
                  },
                  err => {
                    return false
                  }
                )
                return result
              } else {
                return true
              }
            }}
            onChangeValue={value => {
              updateUserStatus([userid], value ? 1 : 2)
            }}
          />
        )
      }
    },
    phone: {
      title: _$('电话'),
      minWidth: 120
    },
    email: {
      title: _$('邮箱'),
      minWidth: 200,
      template({ email }) {
        return <p className="text-overflow">{email}</p>
      }
    },
    usergroup: {
      title: _$('所属组'),
      minWidth: 200,
      template({ usergroup }) {
        return (
          <div className="ksc-space">
            {usergroup?.length &&
              usergroup.map(({ name, usrgrpid }) => <span key={usrgrpid}>{name}</span>)}
          </div>
        )
      }
    },
    active: {
      title: _$('操作'),
      minWidth: 120,
      template(item) {
        const { userid, name } = item
        return (
          <div className="ksc-space">
            <a
              className="primary-color"
              onClick={() => {
                setDrawerVisible(true)
                setCurUser({
                  ...item
                })
              }}
            >
              {_$('编辑')}
            </a>
            <Divider />
            <a
              className="primary-color"
              onClick={() => {
                let dialog: Dialog
                Dialog.confirm({
                  title: name,
                  content: _$('确认删除所选联系人'),
                  ref: _dialog => (dialog = _dialog),
                  okText: _$('确认删除'),
                  ok: async () => {
                    dialog.showLoading()
                    await deleteUser([userid])
                    dialog.close()
                  }
                })
              }}
            >
              {_$('删除')}
            </a>
          </div>
        )
      }
    }
  }

  // filter table
  useEffect(() => {
    run({
      Query: query,
      Enabled: tableGroup.status || '',
      PageIndex: 1
    })
  }, [tableGroup.status])

  return (
    <div className={className}>
      <div className="header">
        <Button
          type="primary"
          onClick={() => {
            setCurUser({})
            setDrawerVisible(true)
          }}
        >
          <Icon className="ion-person-add"></Icon>
          {_$('新建联系人')}
        </Button>
        <MonitorSearch
          placeholder={_$('搜索关键词')}
          value={query}
          onChange={value => {
            setQuery(value)
            run({
              Query: value,
              Enabled: tableGroup.status || '',
              PageIndex: 1
            })
          }}
        />
      </div>
      <div className="table marginTop">
        <TablePage
          tableProps={{
            scheme: tableScheme,
            data: tableData,
            resizable: true,
            stickHeader: 50,
            rowCheckable: false,
            checkType: 'none',
            rowKey: item => item.userid,
            group: tableGroup,
            onChangeGroup: value => {
              setTableGroup({
                status: value.status
              })
            }
          }}
          pageProps={{ total, ...pageState }}
          loading={loading}
          run={run}
        />
      </div>
      <ContactsDrawer
        visible={drawerVisible}
        closeDrawer={(update = false) => {
          setCurUser({})
          setDrawerVisible(false)
          update &&
            run({
              Query: query,
              Enabled: tableGroup.status || '',
              PageIndex: 1
            })
        }}
        curUser={curUser}
      />
    </div>
  )
}
export default styled(Contacts)`
  .table p {
    margin-bottom: 0;
  }
`
